(() => {
 'use strict';
 function init(root=document){
  root.querySelectorAll('[data-dg-catalog]:not([data-dg-ready])').forEach(el=>{
   el.dataset.dgReady='true';
   el.addEventListener('click',e=>{
    const button=e.target.closest('[data-dg-filter]');if(!button)return;
    const filter=button.dataset.dgFilter;
    el.querySelectorAll('[data-dg-filter]').forEach(b=>{const yes=b===button;b.classList.toggle('active',yes);b.setAttribute('aria-pressed',yes)});
    el.querySelectorAll('[data-dg-use]').forEach(card=>card.hidden=filter!=='todos'&&!card.dataset.dgUse.split(' ').includes(filter));
   });
  });
  root.querySelectorAll('[data-dg-product]:not([data-dg-ready])').forEach(el=>{
   el.dataset.dgReady='true';
   const q=s=>el.querySelector(s),variants=JSON.parse(q('[data-dg-variants]').textContent);
   const format=el.dataset.moneyFormat||'${{amount}}';
   const group=(n,sep)=>String(Math.trunc(n)).replace(/\B(?=(\d{3})+(?!\d))/g,sep);
   const money=cents=>format.replace(/\{\{\s*(\w+)\s*\}\}/,(m,key)=>{
    const value=cents/100;
    if(key==='amount_no_decimals')return group(Math.round(value),',');
    if(key==='amount_with_comma_separator')return group(value,'.')+','+Math.round(Math.abs(value)%1*100).toString().padStart(2,'0');
    if(key==='amount_no_decimals_with_comma_separator')return group(Math.round(value),'.');
    if(key==='amount_with_apostrophe_separator')return group(value,"'")+'.'+Math.round(Math.abs(value)%1*100).toString().padStart(2,'0');
    if(key==='amount_no_decimals_with_space_separator')return group(Math.round(value),' ');
    return group(value,',')+'.'+Math.round(Math.abs(value)%1*100).toString().padStart(2,'0');
   }).replace(/<[^>]+>/g,'').trim();
   const decimalSep=/comma_separator/.test(format)?',':'.';
   const perUnit=cents=>{const value=cents/100;const whole=Math.floor(value);const frac=Math.round((value-whole)*100);return frac===0||frac===100?money(Math.round(value)*100):money(whole*100)+decimalSep+String(frac).padStart(2,'0')};
   function update(){
    const v=variants.find(v=>String(v.id)===q('[data-dg-variant]').value);if(!v)return;
    const quantity=Math.max(1,parseInt(q('[data-dg-quantity]').value,10)||1);
    q('[data-dg-quantity]').value=quantity;
    const parsed=v.title.match(/(\d+)\s*unidades/i)||el.dataset.productTitle.match(/(\d+)\s*unidades/i);
    const units=Number(v.units)||(parsed?Number(parsed[1]):0);
    q('[data-dg-price]').textContent=money(v.price);
    const was=q('[data-dg-compare]');const compare=Number(v.compare)||0;
    if(compare>v.price){was.hidden=false;was.querySelector('s').textContent=money(compare);was.querySelector('b').textContent=el.dataset.saveLabel+' '+Math.round((compare-v.price)*100/compare)+'%';}else{was.hidden=true;}
    q('[data-dg-total]').textContent=money(v.price*quantity);
    q('[data-dg-unit]').textContent=units?perUnit(v.price/units)+' '+el.dataset.unitLabel+' · '+units+' '+el.dataset.unitsLabel:'';
    q('[data-dg-units]').textContent=quantity+' '+el.dataset.packLabel+(units?' · '+(quantity*units).toLocaleString('es-CL')+' '+el.dataset.unitsLabel:'');
    q('[data-dg-add]').disabled=!v.available;
    q('[data-dg-add]').textContent=v.available?el.dataset.addLabel+' →':el.dataset.soldLabel;
    q('[data-dg-minus]').disabled=quantity<=1;
    if(v.image)q('.dg-main-image').src=v.image;
    const u=new URL(location.href);u.searchParams.set('variant',v.id);history.replaceState({},'',u);
   }
   q('[data-dg-variant]').addEventListener('change',update);
   q('[data-dg-quantity]').addEventListener('change',update);
   q('[data-dg-minus]').addEventListener('click',()=>{q('[data-dg-quantity]').value=Number(q('[data-dg-quantity]').value)-1;update()});
   q('[data-dg-plus]').addEventListener('click',()=>{q('[data-dg-quantity]').value=Number(q('[data-dg-quantity]').value)+1;update()});
   el.querySelectorAll('[data-dg-image]').forEach(b=>b.addEventListener('click',()=>{
    q('.dg-main-image').removeAttribute('srcset');q('.dg-main-image').src=b.dataset.dgImage;
   }));
   update();
  });
 }
 if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',()=>init());else init();
 document.addEventListener('shopify:section:load',e=>init(e.target));
 const renderCartCount=count=>document.querySelectorAll('[data-dg-cart-count]').forEach(el=>el.textContent=String(count));
 import('@shopify/events').then(({StandardEvents})=>{
  document.addEventListener(StandardEvents.cartLinesUpdate,event=>{
   event.promise?.then(({cart,detail})=>{
    const count=cart?.totalQuantity??detail?.itemCount;
    if(typeof count==='number')renderCartCount(count);
   }).catch(()=>{});
  });
 }).catch(()=>{});
 window.addEventListener('pageshow',event=>{
  if(event.persisted)fetch((window.Shopify?.routes?.root||'/')+'cart.js').then(r=>r.json()).then(cart=>renderCartCount(cart.item_count)).catch(()=>{});
 });
})();

/* v4: oculta el widget de reseñas mientras el producto no tenga reseñas */
(function(){var hide=function(){var w=document.getElementById('judgeme_product_reviews');if(!w)return;var t=(w.innerText||'');var hasCards=w.querySelector('.jm-review-card, .jdgm-rev');if(!hasCards&&/primer[oa] en escribir|No se encontraron|Be the first/i.test(t)){w.style.display='none';}else if(hasCards){w.style.display='';}};hide();var o=new MutationObserver(hide);window.addEventListener('DOMContentLoaded',function(){var w=document.getElementById('judgeme_product_reviews');if(w)o.observe(w,{childList:true,subtree:true});hide();});var w0=document.getElementById('judgeme_product_reviews');if(w0)o.observe(w0,{childList:true,subtree:true});setTimeout(hide,1500);setTimeout(hide,4000);})();
